import React from "react";

export const TrafficLightEditIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="#F3F3F4"
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    width="800px"
    height="800px"
    viewBox="0 0 75.484 75.485"
    {...props}
  >
    <g>
      <title>Layer 1</title>
      <g id="svg_1">
        <path
          d="m32.711,10.901c0,0.608 0.111,1.185 0.272,1.741c-0.54,-0.872 -0.867,-1.888 -0.867,-2.987c0,-3.144 2.549,-5.69 5.69,-5.69c1.101,0 2.122,0.327 2.988,0.867c-0.557,-0.16 -1.13,-0.271 -1.738,-0.271c-3.505,-0.003 -6.345,2.834 -6.345,6.34zm6.344,14.536c0.606,0 1.182,0.113 1.738,0.274c-0.871,-0.54 -1.888,-0.867 -2.988,-0.867c-3.141,0 -5.69,2.545 -5.69,5.69c0,1.102 0.327,2.118 0.867,2.987c-0.159,-0.556 -0.272,-1.133 -0.272,-1.74c0.001,-3.503 2.841,-6.344 6.345,-6.344zm-10.901,16.324l19.176,0l0,19.175l-8.42,0l0,2.998l1.168,0l0,11.551l-4.672,0l0,-11.551l1.168,0l0,-2.998l-8.42,0l0,-19.175zm2.875,9.59c0,3.707 3.006,6.711 6.713,6.711c3.708,0 6.714,-3.004 6.714,-6.711s-3.006,-6.711 -6.714,-6.711c-3.707,0 -6.713,3.004 -6.713,6.711zm-4.193,-14.531l0,-12.705l-6.952,0l6.952,12.705zm0,-20.88l0,-12.704l-6.952,0l6.952,12.704zm21.813,-12.704l0,12.704l6.951,-12.704l-6.951,0zm-21.813,54.466l0,-12.705l-6.952,0l6.952,12.705zm1.318,-36.819l19.176,0l0,19.175l-19.176,0l0,-19.175zm2.875,9.585c0,3.708 3.006,6.713 6.713,6.713c3.708,0 6.714,-3.003 6.714,-6.713c0,-3.707 -3.006,-6.71 -6.714,-6.71c-3.707,0 -6.713,3.003 -6.713,6.71zm17.62,27.234l6.95,-12.705l-6.95,0l0,12.705zm-20.495,-57.702l19.176,0l0,19.174l-19.176,0l0,-19.174zm2.875,9.589c0,3.707 3.006,6.71 6.713,6.71c3.708,0 6.714,-3.003 6.714,-6.71c0,-3.708 -3.006,-6.713 -6.714,-6.713c-3.707,0 -6.713,3.003 -6.713,6.713zm17.62,27.231l6.95,-12.705l-6.95,0l0,12.705zm-9.594,9.499c0.606,0 1.182,0.112 1.738,0.274c-0.871,-0.539 -1.888,-0.867 -2.988,-0.867c-3.141,0 -5.69,2.546 -5.69,5.689c0,1.104 0.327,2.119 0.867,2.988c-0.159,-0.557 -0.272,-1.132 -0.272,-1.738c0.001,-3.503 2.841,-6.346 6.345,-6.346z"
          id="svg_2"
        />
      </g>
      <g id="svg_3">
        <path
          id="svg_4"
          strokeWidth="1.5"
          stroke="#1C274C"
          d="m69.13305,2.2287l-0.9268,0.92688l-8.52128,8.52124l-0.00001,0c-0.57715,0.5772 -0.86573,0.8657 -1.11391,1.1839c-0.29277,0.3754 -0.54376,0.7815 -0.74856,1.2112c-0.17361,0.3643 -0.30266,0.7515 -0.56078,1.5258l-1.09375,3.2813l-0.26736,0.8021c-0.12702,0.381 -0.02785,0.8011 0.25618,1.0852c0.28403,0.284 0.70415,0.3832 1.08521,0.2562l0.80208,-0.2674l3.28126,-1.0938l0.00001,0c0.77434,-0.2581 1.16151,-0.3871 1.52579,-0.5607c0.42971,-0.2048 0.83584,-0.4558 1.21122,-0.7486c0.3182,-0.2482 0.6067,-0.5368 1.1839,-1.1139l0,0l8.5212,-8.52127l0.9269,-0.92687c1.5357,-1.53571 1.5357,-4.02558 0,-5.56128c-1.5357,-1.53571 -4.0256,-1.53571 -5.5613,0z"
        />
        <path
          id="svg_5"
          strokeWidth="1.5"
          stroke="#1C274C"
          d="m68.20615,3.15504c0,0 0.1159,1.96962 1.8538,3.70752c1.7379,1.7379 3.7075,1.85376 3.7075,1.85376m-15.72341,12.0383l-1.87611,-1.8762"
          opacity="0.5"
        />
      </g>
    </g>
  </svg>
);
